export default "__VITE_ASSET__CKx$BUtp__"